import { gql } from "react-apollo";

export const merchantDetails = gql`
  query merchantDetails($merchantId: ID!) {
    merchant(id: $merchantId) {
      contact_people {
        name
        phone
        email
      }
      store_infos {
        address
        address2
        address3
        city
        area_code
        store_area {
          name
        }
        store_province {
          name
        }
      }
    }
  }
`;
